module.exports = __webpack_public_path__ + "85b46eec15947f844e28b358ab188c7b.svg";